import styled from 'styled-components';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const Card = styled(Flex)
    .withConfig({ displayName: 'Card' })
    .attrs((props) => ({
        ...props,
        position: 'relative',
        target: '_blank',
        rel: 'noopener noreferrer',
        backgroundColor: 'var(--background-secondary)',
        overflow: 'hidden',
        borderRadius: 3,
        p: 0.5,
        textDecoration: 'none',
        direction: 'column',
    }))`
        align-items: normal;
    `;

export const Title = styled(Typography)
    .withConfig({ displayName: 'Title' })
    .attrs((props) => ({
        ...props,
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }))`
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;
